import { ListNsnCandidatesResponse } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const NSN_CANDIDATES_QUERY_KEY = 'nsnCandidates';

export const useNsnCandidates = (partNumber: string, enabled: boolean) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  return useQuery<ListNsnCandidatesResponse>({
    queryKey: [NSN_CANDIDATES_QUERY_KEY, tenantId, partNumber],
    queryFn: async () => {
      const response = await api.tenants.listNsnCandidates(tenantId, partNumber);
      return response.data;
    },
    enabled: enabled && !!tenantId,
  });
};
